import { FormsValidation } from "./next-gen-config-wip";
import { AttachmentRule } from "../features/personal-info/attachments/models/AttachmentRule";
import { Logo } from "../components/common/Logo/models/Logo";
import { DeepReadonly } from "../types/utilityTypes";

export const SERVER_API_URL = String(import.meta.env.VITE_BASE_URL);
export const AUTH_HEADER = "oa-token";
export const TIMEOUT = 60 * 1000;
export const UNAUTHORIZED = 401;
export const SERVICE_UNAVAILABLE = 503;
export const AGREEMENT_PAGE_INDEX_WITH_GSG_STEP = 4;
export const AGREEMENT_PAGE_INDEX_WITHOUT_GSG_STEP = 3;
export const PAYMENT_PAGE_INDEX_WITHOUT_GSG_STEP = 4;
export const PAYMENT_PAGE_INDEX_WITH_GSG_STEP = 5;
export const CONFIRMATION_PAGE_INDEX_WITHOUT_PAYMENT = 5;
export const CONFIRMATION_PAGE_INDEX_WITH_PAYMENT = 6;
export const ONLY_DIGITS_REGEX = /^[0-9]+$/;
export const IS_PROD = import.meta.env.VITE_ENVIRONMENT_NAME === "prod";
export const IS_LOCAL = import.meta.env.VITE_ENVIRONMENT_NAME === "LOCAL";
export const DEFAULT_MINIMUM_PHONE_NUMBER_LENGTH = 7;
export const DEFAULT_MAXIMUM_PHONE_NUMBER_LENGTH = 15;
export const DEFAULT_NAMES_PATTERN = RegExp(
  /^[\p{Lower}\p{Upper}\s\-'ʻ`‘]*$/u,
  "u"
);
export const ONLY_SPECIAL_SIGNS_REGEX = /^[$&+,:;=?@#|'ʻ`‘<>.^*()[\]{}%!\s-]+$/;
export const DEFAULT_ACCEPTED_ATTACHMENT_EXTENSIONS = [
  ".jpg",
  ".jpeg",
  ".png",
  ".pdf",
  ".bmp",
];

export type CountryFormConfiguration = DeepReadonly<{
  readonly id: string;
  readonly addressLength?: number;
  readonly footerLogos: Logo[];
  readonly deliveryPriceKeys: DeliveryPriceKeys[];
  readonly footerLinks: FooterLinks[];
  readonly forms: Required<Pick<FormsValidation["forms"], "personalInfo">> &
    Partial<Pick<FormsValidation["forms"], "shippingAddress">>;
  readonly attachments?: AttachmentRule[];
  readonly supportedCountryCodes?: string[];
  readonly [key: string]: null | string | number | boolean | object | undefined;
}>;

interface PhoneNumberRules {
  [countryCode: string]: {
    phoneNumberMinLength: number;
    phoneNumberMaxLength: number;
  };
}

export const MOBILE_RULES: PhoneNumberRules = {
  // Austria
  "43": {
    phoneNumberMinLength: 9,
    phoneNumberMaxLength: 11,
  },
  // Belgium
  "32": {
    phoneNumberMinLength: 9,
    phoneNumberMaxLength: 10,
  },
  // Czech Republic
  "420": {
    phoneNumberMinLength: 9,
    phoneNumberMaxLength: 9,
  },
  // Cyprus
  "357": {
    phoneNumberMinLength: 8,
    phoneNumberMaxLength: 8,
  },
  // Germany
  "49": {
    phoneNumberMinLength: 9,
    phoneNumberMaxLength: 13,
  },
  // Italy
  "39": {
    phoneNumberMinLength: 7,
    phoneNumberMaxLength: 11,
  },
  // Poland
  "48": {
    phoneNumberMinLength: 9,
    phoneNumberMaxLength: 9,
  },
  // Slovakia
  "421": {
    phoneNumberMinLength: 9,
    phoneNumberMaxLength: 9,
  },
  // Spain
  "34": {
    phoneNumberMinLength: 9,
    phoneNumberMaxLength: 10,
  },
  // Switzerland
  "41": {
    phoneNumberMinLength: 8,
    phoneNumberMaxLength: 11,
  },
  // UK
  "44": {
    phoneNumberMinLength: 10,
    phoneNumberMaxLength: 10,
  },
  // Malaysia
  "60": {
    phoneNumberMinLength: 7,
    phoneNumberMaxLength: 10,
  },
  // Taiwan
  "886": {
    phoneNumberMinLength: 10,
    phoneNumberMaxLength: 10,
  },
  // Netherlands
  "31": {
    phoneNumberMinLength: 10,
    phoneNumberMaxLength: 10,
  },
  // France
  "33": {
    phoneNumberMinLength: 10,
    phoneNumberMaxLength: 10,
  },
  //   Vietnam
  "84": {
    phoneNumberMinLength: 9,
    phoneNumberMaxLength: 9,
  },
  //   Thailand
  "66": {
    phoneNumberMinLength: 9,
    phoneNumberMaxLength: 9,
  },
};

export enum Gender {
  MALE = "male",
  FEMALE = "female",
}

export type FooterLinks =
  | "TERMS"
  | "PRIVACY"
  | "COOKIE_POLICY"
  | "RULES_OF_CONDUCT"
  | "COPYRIGHT";

export type DeliveryPriceKeys =
  | "retail"
  | "deliveryTotal"
  | "deliveryLogistic"
  | "deliveryFreight"
  | "tax"
  | "totalAmountToPay";
